import * as gqlTypes from "@hydrologiq/gql/graphql"
import { AttributeValues } from "../ActivityAttributesConfigurable"

export const getAttributeValuesForEventKind = (
  activity: gqlTypes.Activity,
  eventKind: gqlTypes.ActivityEventKind,
  order?: gqlTypes.Order,
  asset?: gqlTypes.Asset
): AttributeValues => {
  if (!activity) {
    return {
      pressure: "",
      quantity: "",
      temperature: "",
      fill_level: "",
      asset: null,
      site: null,
      batch: null,
      source: null,
      destination: null,
      note: null,
    }
  }
  const attrs = activity.attributes?.filter((attr) => attr.event_kind === eventKind) || []

  const values: AttributeValues = {
    pressure: "",
    quantity: "",
    temperature: "",
    fill_level: "",
    asset: null,
    site: null,
    batch: null,
    source: null,
    destination: null,
    note: null,
  }

  attrs.forEach((attr) => {
    switch (attr.attribute) {
      case gqlTypes.ActivityAttributeKind.Pressure:
        values.pressure = attr.value || ""
        break
      case gqlTypes.ActivityAttributeKind.Quantity:
        values.quantity = attr.value || ""
        break
      case gqlTypes.ActivityAttributeKind.Temperature:
        values.temperature = attr.value || ""
        break
      case "fill_level" as any:
        values.fill_level = attr.value || ""
        break
      case gqlTypes.ActivityAttributeKind.Site:
        // Use attr.site?.id if available (when GraphQL query includes site relationship)
        // Otherwise fall back to attr.value (the site ID stored as a string)
        values.site = attr.site?.id || attr.value || null
        break
      case gqlTypes.ActivityAttributeKind.Batch:
        // Use attr.batch?.id if available (when GraphQL query includes batch relationship)
        // Otherwise fall back to attr.value (the batch ID stored as a string)
        values.batch = attr.batch?.id || attr.value || null
        break
      case gqlTypes.ActivityAttributeKind.Source:
        values.source = attr.site?.id || attr.value || null
        break
      case gqlTypes.ActivityAttributeKind.Destination:
        values.destination = attr.site?.id || attr.value || null
        break
    }
  })

  // Get asset from activity.assets (not stored as attribute)
  if (activity.assets && activity.assets.length > 0) {
    values.asset = activity.assets[0].id || null
  } else if (order?.assets?.[0]?.id) {
    // Fallback to first order asset if activity has no assets and order exists
    values.asset = order.assets[0].id
  } else if (asset?.id) {
    values.asset = asset.id
  }

  return values
}
